export const UPDATE_APP_STATE = 'SET_STATE'
export const UPDATE_SPECIFIC_STATE = 'UPDATE_SPECIFIC_STATE'
